module.exports = __webpack_public_path__ + "static/img/motorbike-blue.9a183cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-blue.svg
// module id = 2qha
// module chunks = 74